export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11343.70dd997f.jpg";